<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="配置项key" prop="configKey">
        <el-input v-model.trim="queryParams.configKey" placeholder="请输入配置项key" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="状态" prop="status">
        <el-select-dict dictType="STATUS" clearable placeholder="请选择状态" v-model="queryParams.status"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['system:config:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['system:config:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['system:config:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>

        <el-button v-if="mixinUserInfo.userId === 0" class="fr" type="primary" size="mini"
          @click="downloadDatabaseBackup">数据库备份下载</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="configTable" :class="{ 'empty': list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list" row-key="configId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column :selectable="checkSelectable" type="selection" :reserve-selection="true" width="55"
            align="center" />
          <el-table-column label="配置项key" prop="configKey" align="center" min-width="139px" />
          <el-table-column label="配置项value" prop="configValue" align="center" min-width="128px" />
          <el-table-column-dict v-if="mixinUserInfo.userId === 0" dictType="YES_NO" label="是否仅超管可见" align="center" prop="onlyAdmin"
          min-width="120px"></el-table-column-dict>
          <el-table-column-dict dictType="YES_NO" label="是否系统预设" align="center" prop="isSystem"
            min-width="120px"></el-table-column-dict>
          <el-table-column-dict dictType="STATUS" dictTypeNode="tag" label="状态" align="center" prop="status"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="操作人" prop="creator.userName" show-overflow-tooltip align="center" min-width="168px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建人：</span>
                    <span class="value">{{ scope.row.creator?.userName || "--" }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新人：</span>
                    <span class="value">{{ scope.row.updater?.userName || "--" }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建时间：</span>
                    <span class="value">{{ scope.row.createTime | formatDate("datetime", "--") }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新时间：</span>
                    <span class="value">{{ scope.row.updateTime | formatDate("datetime", "--") }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="
            mixinHasPermi([
              'system:config:status',
              'system:config:read',
              'system:config:delete',
            ])
          " label="操作" align="center" width="256px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['system:config:status']" :disabled="scope.row.isSystem === '1'" size="mini"
                :type="scope.row.status === '1' ? 'warning' : 'success'"
                @click.native.stop="handleStatusChange(scope.row)">{{ scope.row.status === "1" ? "停用" : "启用"
                }}</el-button>
              <el-button v-hasPermission="['system:config:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button v-hasPermission="['system:config:delete']" :disabled="scope.row.isSystem === '1'" size="mini"
                type="danger" icon="el-icon-delete" @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <config-dialog ref="configDialog" :visible.sync="open" :modal-append-to-body="false" :close-on-click-modal="false"
      :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="getList"
      width="1024px"></config-dialog>
  </div>
</template>

<script>
import ConfigDialog from "./components/config-dialog.vue"
import { configApi } from "@/api"
import { downloadFileByBlob } from "@/utils/download"
export default {
  name: "systemConfigManage",
  components: {
    ConfigDialog
  },
  data() {
    return {
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        configKey: "", // 配置项key
        status: "", // 配置项状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        configKey: "", // 配置项key
        configValue: "", // 配置项value
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          configKey: "", // 配置项key
          configValue: "", // 配置项value
          remark: "" // 备注
        }
        this.$refs.configDialog && this.$refs.configDialog.resetForm()
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 下载数据库备份文件
    downloadDatabaseBackup() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      configApi.downloadDatabaseBackup().then(data => {
        // 从缓存中获取文件名 没有则设置 默认文件名
        const fileName = localStorage.getItem("downloadFileName") || "数据库备份.sql"
        downloadFileByBlob(data, fileName, "octet-stream")
        localStorage.removeItem("downloadFileName") // 清除缓存
      })
    },
    // 系统内设用户 禁止操作
    checkSelectable(row, index) {
      if (row.isSystem === "1") {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      //系统预设用户 不做处理
      if (row.isSystem === "1") {
        return
      }
      this.$refs.configTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.configId)
        str += item.configKey
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('是否确认删除配置项key为"【' + str + '】"的数据项？')
        .then(function() {
          return configApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除配置成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.configTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      configApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.configId) {
        this.isUpdate = true
      }
      const id =
        row.configId || (this.selection[0] && this.selection[0].configId)
      configApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const id = row.configId
      this.$modal
        .confirm('是否确认删除配置项Key为"' + row.configKey + '"的数据项？')
        .then(function() {
          return configApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.configId === id)
          flag && this.$refs.configTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    },

    // 状态改变事件
    handleStatusChange(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      configApi
        .changeStatus({
          configId: row.configId,
          status: row.status === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变状态成功")
          this.getList()
        })
    }
  }
}
</script>